<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">Own Vehicle Expense</h1>
        <div>
          <button
            *ngIf="role.isAdmin() || role.isSuperSupervisor()"
            class="btn btn-sm me-2 gap-2 lr-btn"
            mat-raised-button
            matTooltip="Export to Excel"
            matTooltipPosition="left"
            (click)="exportToExcel()"
          >
            Export
          </button>
          <button
            class="btn btn-dark btn-sm"
            matTooltip="Add Expense"
            matTooltipPosition="left"
            mat-raised-button
            routerLink="../addOwnVehicleExpence"
          >
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
      </div>
      <nav class="breadcrumbMaine" aria-label="breadcrumb mb-0">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">Own Vehicle Expense</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="contentbox mt-3">
    <div class="row mb-3">
      <div class="filter-flex">
        <!-- Search Input -->
        <div
          class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 d-flex align-items-center h-100"
        >
          <div class="form-group accountsinp mb-3 flex-fill">
            <label for="search">Search</label>

            <input
              class="search-box form-control"
              #searchInput
              placeholder="Search"
              type="text"
              (input)="onSearchChange($any($event.target).value)"
            />
          </div>
        </div>
        <!-- Date Filters -->

        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
          <div class="d-flex gap-3 flex-wrap">
            <!-- From Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="fromDate">From Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="fromDate"
                [(ngModel)]="fromDate"
                (change)="onDateFilterChange()"
              />
            </div>

            <!-- To Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="toDate">To Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="toDate"
                [(ngModel)]="toDate"
                (change)="onDateFilterChange()"
              />
            </div>
          </div>
        </div>

        <!-- Clear Filters Button -->
        <div class="col-sm-1 d-flex align-items-center h-100">
          <button
            class="clearFilterBtn"
            mat-raised-button
            (click)="clearFilters()"
          >
            <img src="/assets/images/svg/ClearFilter.svg" alt="clear" />
          </button>
        </div>
      </div>
      <!-- <div class="col-md-4">
        <input
          type="text"
          class="form-control"
          placeholder="Search"
          [(ngModel)]="searchText"
          (input)="onSearchChange($any($event.target).value)"
        />
      </div> -->
    </div>

    <div class="row customepadding">
      <div class="col-md-12 table-responsive">
        <table datatable class="row-border hover tablelist">
          <thead>
            <tr>
              <th>Vehicle No</th>
              <th>Vehicle Type</th>
              <th>Expense Date</th>
              <th>Location</th>
              <th>Driver Advance</th>
              <th>Loader Advance</th>
              <th>Police Amount</th>
              <th>Created By</th>
              <th>Created On</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let exp of ownVehicleExpenses">
              <td>
                {{ exp.vehicle?.vehicle_no || "-" }}
              </td>
              <td>
                {{ exp.vehicle?.type || "-" }}
              </td>
              <td>
                {{ exp.expenseDate | date: "dd-MM-yyyy" }}
              </td>

              <td>{{ exp.location || "-" }}</td>

              <td>{{ exp.driverAdvance || 0 }}</td>

              <td>{{ exp.loaderAdvance || 0 }}</td>
              <td>{{ exp.policeAmount || 0 }}</td>

              <td>{{ exp.createdBy?.full_name || "-" }}</td>
              <td>
                {{ exp.createdAt | date: "dd-MM-yyyy" }}
              </td>

              <td>
                <!-- VIEW -->
                <button
                  *ngIf="role.canView()"
                  class="btn btn-block p-0 shadow-none me-2"
                  [routerLink]="[
                    '/superAdmin/manageExpenseLog/ownVehicleExpenseView',
                    exp._id,
                  ]"
                  matTooltip="View"
                >
                  <i class="fas fa-eye"></i>
                </button>

                <!-- EDIT -->
                <button
                  *ngIf="role.canEdit()"
                  class="btn btn-block p-0 shadow-none me-2"
                  matTooltip="Edit"
                  [routerLink]="[
                    '/superAdmin/manageExpenseLog/editOwnVehicleExpence',
                    exp._id,
                  ]"
                >
                  <i class="fa fa-edit"></i>
                </button>

                <!-- DELETE -->
                <button
                  *ngIf="role.canDelete()"
                  class="btn btn-block p-0 shadow-none"
                  matTooltip="Delete"
                  (click)="deleteOwnVehicleExpense(exp._id)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <mat-paginator
        [length]="totalRecords"
        [pageSize]="limit"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
